// Bridge to the Geotab add-in shell (the parent window, a different origin).
// The Vue app requests a fresh session via postMessage; the parent calls
// api.getSession() and posts the result back. See public/geotab/index.html.
export function getGeotabSession(timeout = 8000) {
  return new Promise((resolve, reject) => {
    let settled = false;
    const cleanup = () => {
      if (settled) return;
      settled = true;
      window.removeEventListener("message", onMessage);
      clearTimeout(timer);
    };
    const onMessage = (event) => {
      if (!event.data) return;
      if (event.data.type === "DPB_GEOTAB_SESSION") {
        cleanup();
        resolve(event.data.session);
      } else if (event.data.type === "DPB_GEOTAB_SESSION_ERROR") {
        cleanup();
        reject(new Error(event.data.error || "Geotab session error"));
      }
    };
    const timer = setTimeout(() => {
      cleanup();
      reject(new Error("Timed out waiting for Geotab session."));
    }, timeout);
    window.addEventListener("message", onMessage);
    // targetOrigin '*' is fine: the request carries no secrets. The sensitive
    // session flows back from the parent to our known origin.
    window.parent.postMessage({ type: "DPB_GET_GEOTAB_SESSION" }, "*");
  });
}
